export default __webpack_public_path__ + "static/media/PaulinProfile.33b9057f.jpg";